<template>
	<div id="app">
		<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.15.4/css/all.css"/>
		<router-view />
	</div>
</template>

<template>
	<div :style="cssProps" id="smd" :class="[(collapsed || 
			this.$route.path.startsWith('/form/')) ? 'collapsed' : '', isAuthPage ? 'no-menu' : '']">
		
		<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.15.4/css/all.css"/>

		<saas-navbar
			v-if="!isAuthPage" />

		<div class="smd">
			<notifications position="top center" group="info" />
			<router-view
				@loginSuccess="() => userLoggedIn()"
				@styleUpdated="() => handleUserStyle()" />
		</div>
		<sidebar-menu
			v-if="!isAuthPage"
			width="275px"
			:menu="menu"
			:collapsed="collapsed"
			@collapse="onCollapse"
			:showOneChild="true" />
	</div>
</template>

<script>
	import database from "./services/database.js";
	import users from "./services/users.js";

	import logo from "./components/logo.vue";
	import store from "./store";
	import utils from "./services/utils.js";

	import navbar from "./components/navbar.vue";

	export default {
		props: ["visible"],
		data: function () {
			return {
				menu_color: {},
				collapsed: false,
				menu: [],
				theme: null,
				tablestyle: null,
				user: {},
			};
		},
		computed: {
			cssProps() {
				//console.log("Computing cssProps");

				let finalProps = {
					"--menu_background_color": this.menu_color.background_color,
					"--menu_sub_background_color":
						this.menu_color.sub_background_color,
					"--menu_select_background_color":
						this.menu_color.select_background_color,
					"--menu_icon_background_color":
						this.menu_color.icon_background_color,
					"--menu_select_color": this.menu_color.select_color,
					"--menu_sub_select_color": this.menu_color.sub_select_color,
				};

				if (this.theme !== null) {
					//console.log("Setting theme background color: ", this.theme);
					finalProps = {
						...finalProps,
						...{
							"--theme-font":
								this.theme.text_font + ", sans serif",
							"--theme-background-color":
								this.theme.background_color,
							"--theme-text-color": this.theme.text_color,
							"--theme-text-color-light":
								this.theme.text_color_light,
						},
					};
				}

				if (this.tablestyle !== null) {
					finalProps = {
						...finalProps,
						...{
							"--tables-header-background":
								this.tablestyle.header_background_color,
							"--tables-header-text-color":
								this.tablestyle.header_text_color,
							"--tables-cell-background":
								this.tablestyle.cell_background_color,
							"--tables-cell-text-color":
								this.tablestyle.cell_text_color,
							"--tables-col-border-thickness":
								this.tablestyle.col_border_thickness,
							"--tables-row-border-thickness":
								this.tablestyle.row_border_thickness,
							"--tables-border-color":
								this.tablestyle.border_color,
						},
					};
				}
				return finalProps;
			},
			themeFontFamily() {
				return this.theme === null
					? ""
					: `font-${this.theme.text_font}`;
			},
			themeBackgroundColor() {
				// return ("bg-[#ffadad]")
				return this.theme === null
					? ""
					: `bg-[${this.theme.background_color}]`;
			},
			isAuthPage() {
				return (
					this.$route.path.startsWith("/login") ||
					this.$route.path.startsWith("/form/") ||
					this.$route.path.startsWith("/register") ||
					this.$route.path.indexOf("/password") !== -1
				);
			},
		},
		components: {
			logo,
			"saas-navbar": navbar,
		},
		created: async function () {
			var self = this;

			document.title = process.env.VUE_APP_NAME || "Smartmydata";

			var link = document.querySelector("link[rel~='icon']");
			link.href = process.env.VUE_APP_FAVICON || "/favicon.ico";

			try {
				var response = await users.getSelf(true);
				if (response) {
					//console.log("In app, found user setting style");
					this.user = response.user;
					this.client = response.client;
					if (this.client.details && this.client.details.style)
						store.commit("setStyle", this.client.details.style);
				}
			} catch (err) {
				console.warn(err);
			}

			await this.menu_style(store.state.style);

			await this.buildMenu();

			this.unsubscribe = this.$store.subscribe((mutation, state) => {
				if (
					mutation.type === "setStyle" ||
					mutation.type === "removeStyle"
				) {
					self.menu_style(state.style);
				}
			});

			this.collapsed = store.state.collapsed;
		},
		beforeDestroy() {
			this.unsubscribe();
		},
		methods: {
			userLoggedIn() {
				//console.log("Logged in");
				this.handleUserStyle();
			},
			async handleUserStyle() {
				try {
					var response = await users.getSelf(true);

					// * necessaire de instantanément set le style ??
					if (response) {
						this.user = response.user;
						this.client = response.client;
						if (this.client.details && this.client.details.style)
							store.commit("setStyle", this.client.details.style);
					}
				} catch (err) {
					console.warn(err);
				}

				//console.log("State style after user login ", store.state.style);

				await this.menu_style(store.state.style);
			},
			async menu_style(data) {
				if (data && data.menu && Object.keys(data.menu).length !== 0) {
					this.menu_color = data.menu;
					//console.log("Setting menu style");
				} else {
					//console.log("Style vide !");
					this.menu_color = {
						background_color: "#2a2a2e",
						sub_background_color: "#36363b",
						select_background_color: "#4285f4",
						icon_background_color: "#1e1e21",
						select_color: "rgba(30,30,33,.5)",
						sub_select_color: "rgba(30,30,33,.5)",
					};
				}

				if (data && data.theme) {
					this.theme = data.theme;
				} else {
					//console.log("Tombé dans un theme vide !");
					this.theme = {}; // * rare de tomber ici
				}

				if (data && data.tablestyle) this.tablestyle = data.tablestyle;
				else this.tablestyle = null;
			},
			async buildMenu() {
				var self = this;

				try {
					var user = {};
					var response = await users.getSelf(true).catch(err =>
					{
						self.$router.push({ name: "login" });
						return null;
					});
					if (response) {
						user = response.user;
						this.client = response.client;

						await users.reniew()
					}
					else
					{
						console.log("no user")
						return;
					}

					if (
						!user &&
						(!this.from ||
							(this.from && !this.from.name.startsWith("login")))
					)
						this.$router.push({ name: "login" });

					this.$store.commit("setUser", user);

					// console.log(user)

					this.menu = [
						/*{
            header: true,
            title: 'Smartmydata',
          },*/
						{
							header: true,
							component: logo,
						},
					];

					// traitements

					var items = [];

					if (this.client.details && this.client.details.actions && (user.rules == null || user.rules.actions))
					{
						this.menu.push({
							href: "/actions",
							title: "Actions",
							icon: "fa fa-play",
						});
					}

					if (this.client.details && this.client.details.dashboard && (user.rules == null || user.rules.dashboard))
					{
						this.menu.push({
							href: "/dashboard",
							title: "Tableau de bord",
							icon: "fa fa-columns",
						});
					}

					if (user.rules == null || (user.rules.projects && !user.rules.hide_create_projects)) {
						items.push({
							href: "/create",
							title: "Traitement",
							icon: "fa fa-plus-square",
						});
						if (user.rules == null || user.rules.workflow)
							items.push({
								href: "/workflow/execute",
								title: "Workflow",
								icon: "fa fa-plus-square"
							});
						/*if (user.rules == null || user.rules.projects_csv)
							items.push({
								href: "/test",
								title: "Traitement csv",
								icon: "fa fa-plus-square",
							});*/
						if (user.rules == null || user.rules.projects_list)
							items.push({
								href: "/treatments",
								title: "Liste traitements",
								icon: "fa fa-folder",
							});
						if (user.rules == null || user.rules.variants)
							items.push({
								href: "/variants",
								title: "Variantes",
								icon: "fas fa-cogs",
							});
					}

					if (this.client.details && this.client.details.pages && this.client.details.pages.gcr && this.client.details.pages.gcr.active) {
						if (user.rules == null || user.rules.library || (user.rules.library_type && user.rules.library_type.mapping_salaries))
							items.push({
								href: "/gcr/mapping",
								title: "Fichier salarié",
								icon: "fa fa-cogs",
							});
					}

					if (this.client.details && this.client.details.viewver) {
						for (
							var i = 0;
							i < this.client.details.viewver.length;
							i++
						) {
							items.push({
								href:
									"/visualisation/" +
									this.client.details.viewver[i].name,
								title: this.client.details.viewver[i].name,
								icon: "fa fa-eye",
							});
						}
					}

					if (this.client.details && this.client.details.pages && this.client.details.pages.phar_excel_validate_onp) {
						items.push({
							href: "/phar_excel/validate_onp",
							title: "Validation ONP",
							icon: "fa fa-eye",
						});
					}

					if (this.client.details && this.client.details.pages && this.client.details.pages.green_musicians && this.client.details.pages.green_musicians.active) {
						items.push({
							href: "/green_musicians/validate_products",
							title: "Validation produits",
							icon: "fa fa-eye",
						});
					}

					if (this.client.details && this.client.details.validation && (user.rules == null || user.rules.validation)) {
						items.push({
							href: "/validation",
							title: "Validation",
							icon: "fa fa-eye",
						});
					}

					if (items.length > 0) {
						this.menu.push({
							href: items[0].href,
							title: "Traitements",
							icon: "fa fa-plus-square",
							child: items,
						});
					}

					if (this.client.details && this.client.details.formulaire) {
						if (user.rules == null || user.rules.formulaire)
						this.menu.push({
							href: "/formulaire",
							title: "Formulaire",
							icon: "fas fa-th-list",
						});
					}
					
					if (user.rules == null || user.rules.tickets)
					{
						this.menu.push({
							href: "/tickets",
							title: "Tickets",
							icon: "fa fa-ticket-alt",
						});
					}
					
					if (user.rules == null || user.rules.messages)
					{
						this.menu.push({
							href: "/messages",
							title: "Messages",
							icon: "fa fa-envelope",
						});
					}

					var items = [];

					if (user.rules == null || user.rules.scenarios) {
						items.push(
							{
								href: "/scenario",
								title: "Scénario V2",
								icon: "fas fa-cogs",
							}
						);
					}
					if (user.rules == null || user.rules.workflow)
						items.push({
							href: "/workflow",
							title: "Workflow",
							icon: "fa fa-cogs",
						});
					if (user.rules == null || user.rules.scraping)
						items.push({
							href: "/scraping",
							title: "Scraping",
							icon: "fas fa-cogs",
						});
					if (user.rules == null || user.rules.form)
						items.push({
							href: "/form",
							title: "Formulaire",
							icon: "fas fa-cogs",
						});
					if (user.rules == null || user.rules.decument_extraction)
						items.push({
							href: "/extraction_document",
							title: "Documents",
							icon: "fas fa-cogs",
						});
					if (user.rules == null || user.rules.elements)
						items.push({
							href: "/element",
							title: "Editeur d'éléments",
							icon: "fas fa-cogs",
						});
					if (user.rules == null || (user.rules.library && !user.rules.library_hide_menu))
					{
						items.push({
							href: "/bibliotheque",
							title: "Bibliothèque",
							icon: "fas fa-cogs",
						});
						/*items.push({
							href: "/caracteristiques",
							title: "Caractéristiques",
							icon: "fas fa-cogs",
						});*/
					}

					if (user.rules == null || user.rules.ensemble)
						items.push({
							href: "/ensemble",
							title: "Ensemble",
							icon: "fas fa-cogs",
						});
					if (user.rules == null || user.rules.compare)
						items.push({
							href: "/compare",
							title: "Comparaison",
							icon: "fas fa-cogs",
						});
					
					if (this.client.details && this.client.details.pages && this.client.details.pages.green_musicians && this.client.details.pages.green_musicians.active) {
						items.push({
							href: "/green_musicians/google_search",
							title: "Recherche Google",
							icon: "fas fa-search",
						});
					}

					if (items.length > 0) {
						this.menu.push({
							href: items[0].href,
							title: "Studio",
							icon: "fas fa-cogs",
							child: items,
						});
					}

					var items = [];

					if (user.rules == null || user.rules.planification) {
						items.push({
							href: "/planification",
							title: "Planification",
							icon: "far fa-calendar-alt",
						});
					}

					if (user.rules == null || user.rules.credentials) {
						items.push({
							href: "/credentials",
							title: "Clés de sécurité",
							icon: "fas fa-key",
						});
					}

					if (user.rules == null || user.rules.client_var) {
						items.push({
							href: "/var",
							title: "Variables",
							icon: "fas fa-key",
						});
					}

					if (user.rules == null || user.rules.notifications) {
						items.push({
							href: "/notifications_client",
							title: "Notifications",
							icon: "fas fa-cogs",
						});
					}

					if (user.rules == null || user.rules.groupes)
						items.push({
							href: "/groupes",
							title: "Groupes",
							icon: "fas fa-users",
						});

					if (user.rules == null || user.rules.utilisateurs)
						items.push({
							href: "/utilisateurs",
							title: "Utilisateurs",
							icon: "fas fa-users",
						});

					if (user.rules == null || user.rules.fields_profile)
						items.push({
							href: "/edit-profile",
							title: "Champs de profil",
							icon: "fas fa-user",
						});

					if (user.rules == null || user.rules.style)
						items.push({
							href: "/style",
							title: "Style",
							icon: "fa fa-palette",
						});

					if (user.rules == null || user.rules.env)
						items.push({
							href: "/envs",
							title: "Environnements",
							icon: "fas fa-cogs",
						});

					if (user.rules == null || user.rules.tags)
						items.push({
							href: "/tags",
							title: "Tags",
							icon: "fas fa-tag",
						});

					if (user.rules == null || user.rules.decument_extraction_configuration)
						items.push({
							href: "/extraction_document_configuration",
							title: "Documents",
							icon: "fas fa-cogs",
						});
						
					if (user.rules == null || user.rules.viewver_params)
						items.push({
							href: "/visualisation/parametres",
							title: "Visualisation",
							icon: "fas fa-cogs",
						});

					if (this.client.details && this.client.details.actions_config && (user.rules == null || user.rules.actions_config))
					{
						items.push({
							href: "/actions_config",
							title: "Actions",
							icon: "fas fa-cogs",
						});
					}

					if (items.length > 0) {
						this.menu.push({
							href: items[0].href,
							title: "Configuration",
							icon: "fas fa-cogs",
							child: items,
						});
					}

					if (this.client.details && this.client.details.share && (user.rules == null || user.rules.share))
					{
						items.push({
							href: "/share",
							title: "Partage",
							icon: "fas fa-cogs",
						});
					}

					if (this.client.details && this.client.details.share_get && (user.rules == null || user.rules.share_get))
					{
						items.push({
							href: "/share_get",
							title: "Partage - récupération",
							icon: "fas fa-cogs",
						});
					}

					if (this.client.details && this.client.details.style)
						store.commit("setStyle", this.client.details.style);

					var tables = [];
					if (this.client.details && this.client.details.tables)
						tables = this.client.details.tables;

					var database_tables = null;
					if (
						user.rules != null &&
						user.rules.database == "certaines tables"
					) {
						database_tables = {};

						for (
							var i = 0;
							i < user.rules.database_tables.length;
							i++
						) {
							database_tables[
								user.rules.database_tables[i].name
							] = user.rules.database_tables[i];
						}
					}

					var child = [];

					if (user.rules == null || user.rules.db_requests)
						child.push({
							href: "/database_requests",
							title: "Requêtes",
							icon: "fas fa-cogs",
						});

					if (user.rules == null || user.rules.db_requests_view)
						child.push({
							href: "/database_requests_view",
							title: "Vues multitables",
							icon: "fas fa-cogs",
						});

					if (tables && tables.length > 0) {
						for (var i = 0; i < tables.length; i++) {
							if (
								!tables[i].hide && 
								(!database_tables || !database_tables[tables[i].name] || !database_tables[tables[i].name].hide) &&
								(!database_tables ||
									(database_tables[tables[i].name] && database_tables[tables[i].name].read))
								) 
							{
								child.push({
									href: "/database/" + tables[i].name,
									title: tables[i].name,
								});
							}
						}
					}
					//console.log(child.length)
					if (
						!(
							user.rules != null &&
							user.rules.database == "désactivé"
						) && child.length > 0
					) {
						this.menu.push({
							title: "Base de données",
							icon: "fas fa-database",
							href: "/database",
							child: child,
						});
					}
				} catch (err) {
					console.log(err);
				}

				if (user.rules == null || user.rules.document)
					this.menu.push({
						href: "/document",
						title: "Gestion des documents",
						icon: "fas fa-file",
					});

				if (user.rules == null || user.rules.documentation)
					this.menu.push({
						href: "/documentation",
						external: true,
						title: "Documentation",
						icon: "fas fa-book",
					});
				if (user.client_uid == "4f01cf76-533a-4581-97ba-d6d289bb5444")
					this.menu.push({
						href: "/gcr/documentation",
						title: "Documentation utilisateur",
						icon: "fas fa-book",
					});
					var items = [];


				if (this.isAdmin())
				{
					items.push({
						href: "/notifications",
						title: "Notifications",
						icon: "fas fa-cogs",
					});
					items.push({
						href: "/global_stats",
						title: "Stats générales",
						icon: "fas fa-cogs",
					});
					items.push({
						href: "/admin_credit",
						title: "Credit",
						icon: "fas fa-cogs",
					});
					items.push({
						href: "/admin_client",
						title: "Client",
						icon: "fas fa-cogs",
					});
				}

				if (user.rules == null || user.rules.treatments_stats)
					items.push({
						href: "/stats",
						title: "Stats",
						icon: "fas fa-cogs",
					});

				if (user.rules == null || user.rules.admin)
					items.push({
						href: "/prestashop",
						title: "Prestashop",
						icon: "fas fa-cogs",
					});

				if (user.rules == null || user.rules.doc)
				{
					items.push({
						href: "/doc",
						title: "Doc client",
						icon: "fa fa-eye",
					});
					items.push({
						href: "/graph",
						title: "Structure projets",
						icon: "fa fa-eye",
					});
				}

				if (items.length > 0) {
					this.menu.push({
						href: items[0].href,
						title: "Admin",
						icon: "fas fa-cogs",
						child: items,
					});
				}

				// * maintenant c'est sur la navbar
				//           this.menu.push({
				// 			href: '/profile',
				// 			title: 'Profil',
				// 			icon: 'fa fa-user'
				//           });

				//       this.menu.push({
				//             href: '/logout',
				//             title: 'Déconnexion',
				//             icon: 'fa fa-sign-out-alt'
				//           })
			},
            isAdmin: function() {
                return store.getters.isUserAdmin;
            },
			onCollapse(collapsed) {
				this.collapsed = collapsed;
			},
		},
		watch: {
			collapsed() {
				this.$store.commit("setCollapsed", this.collapsed);
			},
			async $route(to, from) {
				this.from = from;
				if (from.name && from.name.startsWith("login")) {
					await this.buildMenu();

					//console.log("Reloading window");
					//window.location.reload();
				}

				// console.log("Changement de route :", to);
				// todo check si le jwt est toujours valide
				let jwtToken = this.$store.state.jwt;
				// console.log("Récupération du jwt: ", jwtToken);
				let isTokenValid = utils.isTokenValid(jwtToken);
				//console.log("Le token est valide? ", isTokenValid);

				if (isTokenValid === false) {
					this.$notify({
						group: "info",
						title: "Attention:",
						text: "Votre session a expiré, veuillez vous reconnecter.",
						type: "warn",
						duration: -1, // * dure infiniment
						closeOnClick: true,
					});
				}
				// si non, on notifie l'utilisateur
			},
		},
	};
</script>

<style>
	textarea {
		resize: both !important;
	}
	html {
		margin: 0;
		padding: 0;
		height: 100%;
	}
	body {
		font-family: "Source Sans Pro", sans-serif;
		background-color: #f2f4f7 !important;
		min-height: 100%;
	}

	#smd {
		padding-left: 250px;
		font-family: var(--theme-font) !important;
		background-color: var(--theme-background-color) !important;
		color: var(--theme-text-color) !important;

		min-height: 100vh;
	}
	#smd.collapsed {
		padding-left: 50px;
	}
	#smd.no-menu {
		padding-left: 0;
	}
	#smd.no-menu .smd {
		padding: 0;
	}
	.smd {
		padding: 50px;
	}
	.badge-danger {
		background-color: #ff2a2a;
		color: #fff;
	}

	.marge {
		margin-left: 2em;
	}

	/* * si le CSS se calcule avant le JS on a peut-être un probleme */
	.v-sidebar-menu {
		color: #fff;
		background-color: var(--menu_background_color) !important;
	}

	.v-sidebar-menu .vsm-dropdown > .vsm-list {
		color: #fff;
		background-color: var(--menu_sub_background_color) !important;
	}

	.v-sidebar-menu.vsm-default .vsm-item.first-item.open-item > .vsm-link {
		color: #fff;
		background-color: var(--menu_select_background_color) !important;
	}

	.v-sidebar-menu .vsm-mobile-bg {
		color: #fff;
		background-color: var(--menu_select_background_color) !important;
	}

	.v-sidebar-menu .vsm-item.first-item > .vsm-link > .vsm-icon {
		color: #fff;
		background-color: var(--menu_icon_background_color) !important;
	}

	.v-sidebar-menu .collapse-btn {
		color: #fff;
		background-color: var(--menu_icon_background_color) !important;
	}

	.v-sidebar-menu .vsm-dropdown > .vsm-list .vsm-link:hover {
		color: #fff;
		background-color: var(--menu_sub_select_color) !important;
	}

	.v-sidebar-menu.vsm-default .vsm-link:hover {
		color: #fff;
		background-color: var(--menu_select_color) !important;
	}
    .table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {
        background-color: WhiteSmoke;
    }
    .long-tooltip .tooltip-inner
    {
        max-width: 600px !important;
        text-align: left !important;
    }
</style>
